export const ENG_AND_PRODUCT_EMAILS = [
  'ibrilhante@avantstay.com',
  'rpalhares@avantstay.com',
  'mtavares@avantstay.com',
  'liori@avantstay.com',
  'lfantin@avantstay.com',
  'gtakhtamyshev@avantstay.com',
  'fserna@avantstay.com',
  'mbandara@avantstay.com',
  'dev@avantstay.com',
  'abonner@avantstay.com',
  'award@avantstay.com',
  'akamireddi@avantstay.com',
  'lnguyen@avantstay.com',
  'mgarza@avantstay.com',
  'nstacey@avantstay.com',
  'aferreira@avantstay.com',
  'bboltayev@avantstay.com',
  'gdeoliveira@avantstay.com',
  'jamorim@avantstay.com',
  'tprzysiwek@avantstay.com',
  'vfernandes@avantstay.com',
  'vfranca@avantstay.com',
  'wjesus@avantstay.com',
  'zbay@avantstay.com',
  'atarchetti@avantstay.com',
  'apatseev@avantstay.com',
  'dkovalev@avantstay.com',
  'ekholupko@avantstay.com',
  'fpinheiro@avantstay.com',
  'ikudryashova@avantstay.com',
  'lpassos@avantstay.com',
  'jmachado@avantstay.com',
  'mkorolev@avantstay.com',
  'mpantarotto@avantstay.com',
  'reuben@avantstay.com',
  'ybalakhonov@avantstay.com',
  'jpino@avantstay.com',
]

/**
 * @public
 */
export const POD_BODI_EMAILS = [
  'ibrilhante@avantstay.com',
  'rpalhares@avantstay.com',
  'mtavares@avantstay.com',
  'liori@avantstay.com',
  'lfantin@avantstay.com',
  'fserna@avantstay.com',
  'mbandara@avantstay.com',
  'apatseev@avantstay.com',
  'jmachado@avantstay.com',
  'tprzysiwek@avantstay.com',
]

export const STOP_SELL_RULES_EMAILS = [...POD_BODI_EMAILS, 'uusman@avantstay.com']

export const GUEST_INBOX_V2_EMAILS = [
  ...POD_BODI_EMAILS,
  'ctabucchi@avantstay.com',
  'rtorky@avantstay.com',
  'boira@avantstay.com',
  'gmendiola@avantstay.com',
  'greal@avantstay.com',
  'mballesteros@avantstay.com',
  'lcroos@avantstay.com',
]

/**
 * @public
 */
export const PARKING_PASS_EMAILS = [
  ...POD_BODI_EMAILS,
  'sawa@avantstay.com',
  'bestella@avantstay.com',
  'hebarita@avantstay.com',
  'lvillamayor@avantstay.com',
  'mlazaro@avantstay.com',
  'ctabucchi@avantstay.com',
  'micasiano@avantstay.com',
]

/**
 * @public
 */
export const PROPERTY_HISTORY_EMAILS = [
  'reuben@avantstay.com',
  'apatseev@avantstay.com',
  'eilgaz@avantstay.com',
  'lnguyen@avantstay.com',
  'ibrilhante@avantstay.com',
  'mtavares@avantstay.com',
  'jamorim@avantstay.com',
  'lpassos@avantstay.com',
  'jmachado@avantstay.com',
  'fserna@avantstay.com',
  // revenue analysts
  'bchagas@avantstay.com',
  'eespino@avantstay.com',
  'lnamba@avantstay.com',
  'longle@avantstay.com',
  'mhedemann@avantstay.com',
  'mwheeler@avantstay.com',
  'phung@avantstay.com',
  'rmoral@avantstay.com',
  'sfouts@avantstay.com',
  'stan@avantstay.com',
]

/**
 * @public
 */
export const REVENUE_AGENTS_EMAILS = [
  'dev@avantstay.com',
  'reuben@avantstay.com',
  'apatseev@avantstay.com',
  'ekholupko@avantstay.com',
  'lnguyen@avantstay.com',
  'jamorim@avantstay.com',
  'eilgaz@avantstay.com',
  'rmoral@avantstay.com',
  'bchagas@avantstay.com',
  'lnamba@avantstay.com',
  'mhedemann@avantstay.com',
  'ibrilhante@avantstay.com',
  'mbandara@avantstay.com',
  // 'vfranca@avantstay.com',
  // 'atarchetti@avantstay.com',
  'lpassos@avantstay.com',
  'jmachado@avantstay.com',
  'sfouts@avantstay.com',
  'nezihu@avantstay.com',
  'mwheeler@avantstay.com',
  'phung@avantstay.com',
  'longle@avantstay.com',
  'eespino@avantstay.com',
  'stan@avantstay.com',
  'mbonomi@avantstay.com',
  'tprzysiwek@avantstay.com',
]
